var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.206,
    height: 14.345,
    viewBox: "0 0 17.206 14.345",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_11368",
    "data-name": "Path 11368",
    d: "M-2352.855-922.311a1.2,1.2,0,0,1,.7-.567c1.152-.448,2.307-.888,3.461-1.33q5.932-2.271,11.863-4.54a1.361,1.361,0,0,1,.29-.083.73.73,0,0,1,.892.8,6.111,6.111,0,0,1-.168,1.091q-1.219,5.738-2.449,11.474a2.333,2.333,0,0,1-.2.567.667.667,0,0,1-.847.359,1.728,1.728,0,0,1-.51-.243c-1.234-.893-2.461-1.8-3.69-2.7l-.159-.115c-.049.043-.1.081-.139.122q-.942.9-1.884,1.8a.921.921,0,0,1-.686.279c.016-.243.032-.481.049-.718.075-1.051.148-2.1.229-3.151a.368.368,0,0,1,.112-.223q3.572-3.217,7.151-6.427c.017-.015.04-.026.05-.045.045-.083.087-.168.129-.252a.909.909,0,0,0-.306-.053,1,1,0,0,0-.333.152q-4.451,2.781-8.9,5.564a.331.331,0,0,1-.241.042c-1.263-.386-2.522-.78-3.783-1.172a1.022,1.022,0,0,1-.63-.437Z",
    transform: "translate(2352.855 928.843)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.48de406e7676c571b1f85f249f721f9d.svg";
export { ForwardRef as ReactComponent };